<shared-cell-verify [name]="formName" [id]="formName" [invalid]="invalid$ | async" class="form-for-cell-verify__cells"
    (onChange)="handleVerifyChange($event)" (onComplete)="handleVerifyComplete($event)">
</shared-cell-verify>

<ng-template #left>
    <shared-link [emphasis]="emphasis" (onClick)="handleResendCodeClick($event)">Resend my code</shared-link>
</ng-template>

<ng-template #right>
    <shared-forms-submit #btn [tabindex]="5" marginTop="none" width="normal" [loading]="(loading$ | async)"
        class="form-for-cell-verify__submit" type="button" [disabled]="!codeObj.isValid"
        (onClick)="handleCellVerifySubmit($event)">
        Verify</shared-forms-submit>
</ng-template>

<!-- <shared-forms-actions class="form-for-cell-verify__actions" [left]="left" [right]="right">
</shared-forms-actions> -->
<shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right"
    class="form-for-cell-verify__actions">
</shared-forms-offset-wrapper>